import PlatformSpecific from 'x/config/platform-specific'
import OpImplWeb from '../utils/op-impl-web'
import NavImplWeb from '../utils/nav-impl-web'
import CompImplWeb from '../utils/comp-impl-web'

PlatformSpecific.op = new OpImplWeb()
PlatformSpecific.nav = new NavImplWeb()
PlatformSpecific.comp = new CompImplWeb()
PlatformSpecific.l = 'th'
